import LocaleHelper from '../../Core/localization/LocaleHelper.js';
import '../../Scheduler/localization/En.js';

const locale = {

    localeName : 'En',
    localeDesc : 'English (US)',
    localeCode : 'en-US',
    localeRtl  : false,

    EventEdit : {
        Calendar  : 'Calendar',
        'All day' : 'All day',
        day       : 'Day',
        week      : 'Week',
        month     : 'Month',
        year      : 'Year',
        decade    : 'Decade'
    },

    EventMenu : {
        duplicateEvent : 'Duplicate',
        copy           : 'copy'
    },

    Calendar : {
        toggleSidebar : 'Toggle sidebar visibility',
        Today         : 'Today',
        Tomorrow      : 'Tomorrow',
        next          : range => `Next ${range}`,
        previous      : range => `Previous ${range}`,
        plusMore      : value => `+${value} more`,
        moreEvents    : value => `${value} more events`,
        allDay        : 'All day',
        endsOn        : d => `Ends ${d}`,
        weekOfYear    : ([y, w]) => `Week ${w}, ${y}`,
        loadFail      : 'Calendar data load failed. Please contact your system administrator',
        gotoDate      : 'Go to date',
        timeRange     : 'Time range'
    },

    CalendarDrag : {
        holdCtrlForRecurrence : 'Hold CTRL for a recurring event'
    },

    CalendarMixin : {
        eventCount : count => `${count || 'No'} event${count === 1 ? '' : 's'}`
    },

    EventTip : {
        'Edit event' : 'Edit',
        timeFormat   : 'LST'
    },

    ModeSelector : {
        includeWeekends : 'Include weekends',
        weekends        : 'Weekends'
    },

    AgendaView : {
        Agenda : 'Agenda'
    },

    MonthView : {
        Month     : 'Month',
        monthUnit : 'month'
    },

    WeekView : {
        weekUnit : 'week'
    },

    YearView : {
        Year     : 'Year',
        yearUnit : 'year',
        noEvents : 'No events'
    },

    EventList : {
        List   : 'List',
        Start  : 'Start',
        Finish : 'End',
        days   : count => `${count > 1 ? `${count} ` : ''}day${count === 1 ? '' : 's'}`
    },

    DayView : {
        Day                : 'Day',
        dayUnit            : 'day',
        daysUnit           : 'days',
        expandAllDayRow    : 'Expand all-day section',
        collapseAllDayRow  : 'Collapse all-day section',
        timeFormat         : 'LST',
        timeAxisTimeFormat : 'LST',
        noMatchingDates    : 'No matching dates'
    },

    DayAgendaView : {
        dayAgenda : 'Day Agenda'
    },

    DayResourceView : {
        dayResourceView : 'Day resources'
    },

    Sidebar : {
        selectDate      : 'Select calendar date',
        matchEvents     : 'Match events',
        filterEvents    : 'Filter events by event name',
        filterResources : 'Filter events by selected resource'
    },

    WeekExpander : {
        expandTip   : 'Click to expand row',
        collapseTip : 'Click to collapse row'
    }
};

export default LocaleHelper.publishLocale(locale);
